import moment from 'moment';
const RENEVAL_SELECTOR = 'input[data-reneval-date]';
const ISSUE_SELECTOR = 'input[data-issue-date]';

class PoliceCheckRenevalDate {
  constructor() {
    let renevalInput = $(RENEVAL_SELECTOR);
    let issueInput = $(ISSUE_SELECTOR);
    if (issueInput.size()) {
      issueInput.on('dp.change', () => {
        let date = moment(issueInput.val(), 'DD/MM/YYYY');
        date.add(3, 'years');
        renevalInput.val(date.format('DD/MM/YYYY'));
      });
      issueInput.trigger('dp.change');
    }
  }
}

export default PoliceCheckRenevalDate;



// WEBPACK FOOTER //
// ./src/javascripts/PoliceCheckRenevalDate.js